import i1 from '../images/mall/1.png'
import i2 from '../images/mall/2.png'
import i3 from '../images/mall/3.png'
import i4 from '../images/mall/4.png'
import i5 from '../images/mall/5.png'
import i6 from '../images/mall/6.png'
import i7 from '../images/mall/7.png'
import i8 from '../images/mall/8.png'
import i9 from '../images/mall/9.png'
import i10 from '../images/mall/10.png'
import i11 from '../images/mall/11.png'
const productArr = [
  {name: '43寸自助一体机',
    img: [i1]
  },
  {name: '新版43寸自助一体机',
    img: [i6]
  },
  {name: '新版智能存币机',
    img: [i8]
  },
  {name: '智能存票屋',
    img: [i10]
  },
  {name: '桌面售币机',
    img: [i11]
  },
  {name: '安卓刷卡器终端',
    img: [i3]
  },
  {name: '新版刷卡器终端',
    img: [i7]
  },
  {name: '迷你卡头',
    img: [i4]
  },
  {name: '退票版卡头',
    img: [i5]
  },
  {name: 'Z1 PLUS收银POS机',
    img: [i2]
  },
  {name: '智绘闸机',
    img: [i9]
  }
]
export default productArr



// WEBPACK FOOTER //
// ./src/assets/json/product.js